// extracted by mini-css-extract-plugin
export default {"wrapper":"W_PaymentCard_wrapper__rsZR0","title":"W_PaymentCard_title__7SmQY"};